<template>
  <div class="product">
    <div class="banner">
      <div class="title">智能内容生产</div>
      <div class="desc">
        <section>
          10款AIGC专业级内容创作⼯具，实现内容从1-N的⾼效内容裂
        </section>
        <section>变，赋能非专业人士亦可快速完成专业级内容编辑</section>
      </div>
      <router-link target="_blank" to="/contact"
        ><div class="button">立即体验<i class="el-icon-right"></i></div
      ></router-link>
    </div>
    <div class="context">
      <img v-for="item in cardList" :src="item" alt="">
    </div>
    <div class="handler">
      <router-link target="_blank" to="/contact">
        <el-button type="primary">
          预约演示
        </el-button>
      </router-link>
    </div>
    <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/productBanner.vue'
export default {
  name: 'supply',
  data() {
    return {
      cardList: [
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_1.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_2.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_3.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_4.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_5.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_6.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_7.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_8.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_9.png',
        'https://respool.isheji.com/isheji/static/qiye/image/product/output/card_10.png',
      ]
    }
  },
  components: {
    banner
  },
  methods: {
    linkTo(url) {
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.product {
  width: 100%;
  min-width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .banner {
    text-align: center;
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/product/output/banner.png');
    width: 100%;
    min-width: 1400px;
    height: 460px;
    background-size: cover;
    background-position-x: center;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 60px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 45px;
    }
    .desc {
      margin-top: 20px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
      margin-bottom: 32px;
    }
  }
  .context {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 1200px;
    img {
      width: 217px;
      height: 347px;

      &:nth-child(-n+5) {
        margin-top: 57px;
      }
      &:nth-child(n+6) {
        margin-top: 46px;
        margin-bottom: 40px;
      }
    }
  }
  .handler{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 56px;
  }

  .button {
    width: 126px;
    height: 44px;
    background: #5a2df5;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    cursor: pointer;
    .el-icon-right {
      display: none;
      margin-left: 8px;
    }
    &:hover {
      .el-icon-right {
        display: block;
        color: #ffffff;
        margin-left: 8px;
      }
    }
  }
}
</style>
